<table>
  <tr>
    <td style="flex-basis: 5vw" >
      @switch (itemForm().type) {
        @case (FieldTypes.TEXT) {
          <div >
            <p>[TXT]</p>
          </div>
        }
        @case (FieldTypes.DECIMAL) {
          <div >
            <p>[1.23]</p>
          </div>
        }
        @case (FieldTypes.INTEGER) {
          <div >
            <p>[123]</p>
          </div>
        }
        @case (FieldTypes.BOOLEAN) {
          <div >
            <p>[Y/N?]</p>
          </div>
        }
        @case (FieldTypes.MULTI) {
          <div >
            <mat-icon>check_box</mat-icon>
          </div>
        }
        @case (FieldTypes.RADIO) {
          <div >
            <mat-icon>radio_button_checked</mat-icon>
          </div>
        }
        @case (FieldTypes.DEVICES) {
          <div >
            <p>[DEV]</p>
          </div>
        }
        @case (FieldTypes.DROPDOWN) {
          <div >
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
        }
      }
    </td>
    <td style="flex-basis: 8vw">
      {{itemForm().name}}
    </td>
    <td style="flex-basis: 4vw">
      {{itemForm().required ? '(req.)' : '(opt.)'}}
    </td>
    <td style="flex-basis: 6vw">
      {{itemForm().renderTag}}
    </td>
    <td style="flex-basis: 2vw">
      {{itemForm().sort}}
    </td>
    <td style="flex-basis: 15vw">
      {{itemForm().description}}
    </td>
  </tr>
</table>
@if (itemForm().type === FieldTypes.RADIO || itemForm().type === FieldTypes.MULTI || itemForm().type === FieldTypes.DROPDOWN) {
  <div  class="flex-row-grow start-center">
    @for (opt of itemForm().values; track opt; let i = $index) {
      <div>
        <span class="app-multi-label">
          @if (itemForm().type === FieldTypes.RADIO) {
            <span ><mat-icon >radio_button_unchecked</mat-icon></span>
          }
          @if (itemForm().type === FieldTypes.MULTI) {
            <span ><mat-icon>check_box</mat-icon></span>
          }
          @if (itemForm().type === FieldTypes.DROPDOWN) {
            <span ><mat-icon>arrow_drop_down</mat-icon></span>
          }
          {{opt}}
        </span>
      </div>
    }
  </div>
}



